<template>
    <div class="row" style="margin-left: 0px; margin-right: 0px;">
            
                <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <div class="row" style="margin-left: 0px; margin-right: 0px;">
                        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <h5 class="colorText">Titre</h5>
                        </div>
                        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <input type="text" class="form-control" placeholder="Titre" name='title' aria-describedby="basic-addon3" v-model="title">
                        </div>
                    </div>
                </div>
                <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <div class="row" style="margin-left: 0px; margin-right: 0px;">
                        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <h5 class="colorText">Langue</h5>
                        </div>
                        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <div class="form-group">
                                <select name='langue' class="form-control" v-model="langue">
                                    <option disabled value="">Choose</option>
                                    <option>fr</option>
                                    <option>en</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

            <div class="input-group green_line" v-for= "n in formulaire.next" :key="n.id" >
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                </div>

                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                        <input type="text" class="form-control" placeholder="Question" aria-describedby="basic-addon3" v-model="n.intitule">
                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(formulaire,n)" :title="trans.get('common.delete')">
                            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                        </button>
                    </div>

                    <div  class="input-group thin_green_line" v-for= "p in n.next" :key="p.id">

                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                            <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                        </div>

                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">

                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">    
                                <input type="text" class="form-control" placeholder="Réponse" aria-describedby="basic-addon3" v-model="p.intitule"> 
                                <input v-show="p.next.length==0" type="number" class="form-control" placeholder="Coeff PV-Ready" aria-describedby="basic-addon3" v-model="p.valeur">
                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(n,p)" :title="trans.get('common.delete')">
                                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                </button>
                            </div>
                            
                            <div class="input-group" v-for= "k in p.next" :key="k.id">

                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                </div>

                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;"> 
                                        <input type="text" class="form-control" placeholder="Question" aria-describedby="basic-addon3" v-model="k.intitule">
                                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(p,k)" :title="trans.get('common.delete')">
                                            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                        </button>
                                    </div>

                                    <div class="input-group" v-for= "j in k.next" :key="j.id">
                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                            <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                        </div>

                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">    
                                                <input type="text" class="form-control" placeholder="Réponse" aria-describedby="basic-addon3" v-model="j.intitule">
                                                <input v-show="j.next.length==0" type="number" class="form-control" placeholder="Coeff PV-Ready" aria-describedby="basic-addon3" v-model="j.valeur">
                                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(k,j)" :title="trans.get('common.delete')">
                                                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                </button>
                                            </div>

                                            <div class="input-group" v-for= "l in j.next" :key="l.id">

                                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                </div>

                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;"> 
                                                        <input type="text" class="form-control" placeholder="Question" aria-describedby="basic-addon3" v-model="l.intitule">
                                                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(j,l)" :title="trans.get('common.delete')">
                                                            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                        </button>
                                                    </div>

                                                    <div class="input-group" v-for= "m in l.next" :key="m.id">
                                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                            <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                        </div>

                                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">    
                                                                <input type="text" class="form-control" placeholder="Réponse" aria-describedby="basic-addon3" v-model="m.intitule">
                                                                <input v-show="m.next.length==0" type="number" class="form-control" placeholder="Coeff PV-Ready" aria-describedby="basic-addon3" v-model="m.valeur">
                                                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(l,m)" :title="trans.get('common.delete')">
                                                                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                                </button>
                                                            </div>  




                                                            <div class="input-group" v-for= "o in m.next" :key="o.id">

                                                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                                </div>

                                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;"> 
                                                                        <input type="text" class="form-control" placeholder="Question" aria-describedby="basic-addon3" v-model="o.intitule">
                                                                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(m,o)" :title="trans.get('common.delete')">
                                                                            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                                        </button>
                                                                    </div>

                                                                    <div class="input-group" v-for= "q in o.next" :key="q.id">
                                                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                                            <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                                        </div>

                                                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">    
                                                                                <input type="text" class="form-control" placeholder="Réponse" aria-describedby="basic-addon3" v-model="q.intitule">
                                                                                <input v-show="q.next.length==0" type="number" class="form-control" placeholder="Coeff PV-Ready" aria-describedby="basic-addon3" v-model="q.valeur">
                                                                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(o,q)" :title="trans.get('common.delete')">
                                                                                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                                                </button>
                                                                            </div>  
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                                            
                                                                    </div>

                                                                    <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(o,"Reponse")' :title="trans.get('common.add')">
                                                                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                                                <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                                            </div>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                             <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    
                                                            </div>

                                                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(m,"Question")' :title="trans.get('common.add')">
                                                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                                        <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    
                                                    </div>

                                                    <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(l,"Reponse")' :title="trans.get('common.add')">
                                                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                                <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mx-0">
                                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                </div>
                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                    <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(j,"Question")' :title="trans.get('common.add')">
                                                        <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                            <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mx-0">
                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                        </div>
                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                            <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(k,"Reponse")' :title="trans.get('common.add')">
                                                <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="row mx-0">
                             <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                    
                            </div>
                            

                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(p,"Question")'  :title="trans.get('common.add')">
                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                        <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                    </div>
                                </button>
                            </div>
                            </div>



                        </div>
                    </div>
                    <div class="row mx-0">
                     <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    
                    </div>

                    <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">               
                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(n,"Reponse")' :title="trans.get('common.add')">
                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                            </div>
                        </button>
                    </div>
                    </div>
                </div>
            </div>
            <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    
            </div>

            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(formulaire,"Question")'  :title="trans.get('common.add')">
                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                            <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                    </div>
                </button>
            </div>
        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
                <input name="formulaire" type="hidden" id="formulaire" style="visibility:hidden" >
                <button type="button" class="buttonOriginal" v-on:click='save()'  :title="trans.get('common.save')">
                    <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                </button>
        </div>
    </div>
</template>

<script >

    export default {
        props : ['questionnaire'],     
        data : function(){
            return {
                formulaire:{
                    next :[ {
                        id :0,
                        type:"Question",
                        intitule : "",
                        next : [],
                    }],
                },
                title:"",
                langue:"",
                id:1,
                idQ:0,
            };
        },
        mounted: function(){
            
            this.formulaire = JSON.parse(this.questionnaire.building);
            this.title =this.questionnaire.titre;
            this.langue = this.questionnaire.langue;
            this.idQ=this.questionnaire.id;
        },
        methods :{
            add(n,typeP){
                var reponse = {
                    id: this.id,
                    intitule :typeP,
                    type: typeP,
                    next : [],
                    valeur:1,
                }
                n.next.push(reponse);
                this.id++;                
            },
            remove(parent,n){
                
                for ( var i = 0; i<parent.next.length;i++){
                    if(parent.next[i].id == n.id){
                        parent.next.splice(i,1);
                    }
                }
            },
            addQuestion(p){
               var question = {
                   id : this.id,
                   intitule: 'Question',
                   type: 'Question',
                   next:[],
               }    

                p.next.push(question);
                this.id++;   
            },
            
            save(){
                let formData = new FormData();

                var data = JSON.stringify(this.formulaire);
                document.getElementById("formulaire").value=data;
                document.getElementById("saveQuestion").submit();
                
            },
            
                               
            
        },
    }

</script>
